import {useState} from 'react';

export default function useFlag(defaultValue?: boolean) {
  const [flg, setFag] = useState(defaultValue ?? false);
  const on = () => setFag(true);
  const off = () => setFag(false);
  return {flg, on, off};
}
